module.exports = __webpack_public_path__ + "media/images/mobile/abouts/11-72b850aa7db09a86cfd858bf2b459f97.png";